import { Sprite } from '@pixi/sprite';
import { Text } from '@pixi/text';

Text.prototype._renderCanvas = function _renderCanvas(renderer) {
  if (this._autoResolution && this._resolution !== renderer.resolution) {
    this._resolution = renderer.resolution;
    this.dirty = true;
  }
  this.updateText(true);
  Sprite.prototype._renderCanvas.call(this, renderer);
};
//# sourceMappingURL=Text.mjs.map
